{
  "internal_id": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true,
    },
  },
  "last_status_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Date",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "from_company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "From",
      "isShownByDefault": true,
    },
  },
  "to_company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "To",
      "isShownByDefault": true,
    },
  },
  "application_ids": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Application IDs",
      "isShownByDefault": true,
      "isNotRenderable": true,
    },
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["Approved", "Closed", "Withdrawn"],
    },
    "ui": {
      "label": "Status",
      "isShownByDefault": true,
    },
  },
  "wells_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Wells",
      "isShownByDefault": true,
    },
  },
  "pipelines_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Pipelines",
      "isShownByDefault": true,
    },
  },
  "facilities_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Facilities",
      "isShownByDefault": true,
    },
  },
  "grid_ids": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Grid IDs",
      "width": 75,
      "isShownByDefault": true,
      "isNotRenderable": true,
    },
  },
}
